import React from "react";
import { toggleNavCollapsed } from "redux/actions";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import AppScrollbar from "../../../AppScrollbar";
import MainSidebar from "../../components/MainSidebar";
import Drawer from "@mui/material/Drawer";
import VerticalNav from "../../components/VerticalNav";
import StandardSidebarWrapper from "./StandardSidebarWrapper";
// import UserInfo from '../../components/UserInfo';
// import { useSidebarContext } from "../../../../utility/AppContextProvider/SidebarContextProvider";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AppLogo from "../../components/AppLogo";
const AppSidebar = (props) => {
	const dispatch = useDispatch();
	const navCollapsed = useSelector(({ settings }) => settings.navCollapsed);

	// const {sidebarTextColor} = useSidebarContext();

	const handleToggleDrawer = () => {
		dispatch(toggleNavCollapsed());
	};

	return (
		<>
			<Drawer
				anchor={props.position}
				open={navCollapsed}
				onClose={() => handleToggleDrawer()}
				classes={{
					root: clsx(props.variant),
					paper: clsx(props.variant),
				}}
				style={{ position: "absolute" }}
			>
				<StandardSidebarWrapper className="standard-sidebar">
					<MainSidebar>
						{/* <UserInfo color={sidebarTextColor} /> */}
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								pl: 5.5,
								pr: 3,
								borderBottom: '1px solid #DDD'
							}}
						>
							<Box
								sx={{
									"& .logo-text": {
										display: {
											xs: "none",
											sm: "block",
										},
									},
								}}
							>
								<AppLogo />
							</Box>
							<IconButton
								sx={{
									color: "text.secondary",
								}}
								edge="start"
								className="menu-btn"
								color="inherit"
								aria-label="open drawer"
								onClick={() => handleToggleDrawer()}
								size="large"
							>
								<CloseIcon
								// sx={{
								// 	width: 20,
								// 	height: 20,
								// }}
								/>
							</IconButton>
						</Box>
						<AppScrollbar
							sx={{
								py: 2,
								height: "calc(100vh - 70px) !important",
							}}
							scrolltotop={'false'}
						>
							<VerticalNav />
						</AppScrollbar>
					</MainSidebar>
				</StandardSidebarWrapper>
			</Drawer>
		</>
	);
};
export default AppSidebar;

AppSidebar.defaultProps = {
	variant: "",
	position: "left",
};

AppSidebar.propTypes = {
	position: PropTypes.string,
	variant: PropTypes.string,
};
